import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export type Language =
  | 'english'
  | 'spanish'
  | 'portuguese'
  | 'french'
  | 'german'
  | 'mandarin'
  | 'cantonese'
  | 'korean'
  | 'russian'
  | 'arabic'
  | 'vietnamese'
  | 'tagalog'
  | 'american_sign_language'

export const languageMap: Record<Language, MapItem> = {
  english: { label: 'English' },
  spanish: { label: 'Spanish' },
  portuguese: { label: 'Portuguese' },
  french: { label: 'French' },
  german: { label: 'German' },
  mandarin: { label: 'Mandarin' },
  cantonese: { label: 'Cantonese' },
  korean: { label: 'Korean' },
  russian: { label: 'Russian' },
  arabic: { label: 'Arabic' },
  vietnamese: { label: 'Vietnamese' },
  tagalog: { label: 'Tagalog' },
  american_sign_language: { label: 'American Sign Language' },
}

export const languageSchema = z.enum(Object.keys(languageMap) as [Language, ...Language[]])
